import { hasGameStarted } from "./statusHelpers";
import "./ScoreDisplay.sass";

/**
 * Componente ScoreDisplay - Renderiza el marcador del partido
 * 
 * @param {string} leftScore - Puntuación del equipo local
 * @param {string} rightScore - Puntuación del equipo visitante
 * @param {string} score - Texto del score (ej: "VS", "Suspendido")
 * @param {string} gameStatus - Estado del partido
 * @param {string} periodTitle - Título del período (hora o minuto)
 */
export default function ScoreDisplay({
  leftScore,
  rightScore,
  score,
  gameStatus,
  periodTitle
}) {
  const started = hasGameStarted(gameStatus);

  return (
    <div className="score-section">
      <div className={`score ${gameStatus}`}>
        {started ? (
          <span className="score-display">{`${leftScore} - ${rightScore}`}</span>
        ) : (
          <span className="score-display">{score}</span>
        )}
      </div>
    </div>
  );
}
